export const STORE_PROPS = {
  PAYMENT_SERVICES: 'paymentServices',
  ACTIVE_SERVICE_ID: 'activeServiceId',
  ACTIVE_PAYMENT_TYPE: 'activePaymentType',
  IS_PAYMENT_SERVICES_LOADED: 'isPaymentServicesLoaded',
  USER_TOKENS: 'userTokens',
  RESULT_DEPOSIT_DATA: 'resultDepositData',
  RECOMMENDED_DEPOSIT_AMOUNT: 'recommendedDepositAmount',
  MONEYBOX_BALANCE: 'moneyboxBalance',
  CRYPTO_LIMITS: 'cryptoLimits',
  IS_SERVICE_ALLOWED: 'isServiceAllowed'
} as const;
